import Service from "../../../common/services/service";

export default class LicenseProvider extends Service {
  licenseId: string;

  constructor(id: string) {
    super();
    this.licenseId = id;
  }

  save(json): Promise<any> {
    return this.persist({json: json});
  }

  backUp(json) {
    return this.persist({ endpoint: `${this.licenseId}/back_up`, json: json });
  }

  fetchForms(): Promise<any> {
    return this.persist({endpoint: `${this.licenseId}/forms`, method: 'get'});
  }

  linkForm(json: {form_id: string, workflow_step: object}): Promise<any> {
    return this.persist({endpoint: `${this.licenseId}/link_form`, json: json});
  }

  linkNewForm(json: {form: object, workflow_step: object, folder_id_tree: string[]}): Promise<any> {
    return this.persist({endpoint: `${this.licenseId}/link_new_form`, json: json, method: 'post'});
  }

  fetchAwardedLicenses(json: { id: string, published_license_id: string }, query: object = {}) {
    return this.persist({endpoint: `${this.licenseId || json.id}/awarded_licenses`, json: json, method: 'get', query: query});
  }

  persist({endpoint = this.licenseId, json = {}, method = 'put', query = {}}: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const data = {
        _method: method,
        authenticity_token: this.csrfToken()
      };

      window.AppConfig.mergeJson(data, json, query);

      $.ajax({
        url: `/licenses/${endpoint}`,
        type: 'POST',
        dataType: 'json',
        data: data,
      }).done(function (result) {
        resolve(result);
      }).fail(function (result) {
        reject();
      });
    });
  }
}
